import { Container, Row, Col } from 'react-grid-system';

export const Grid = {
  Container,
  Row,
  Col,
};

export { Hidden, Visible } from 'react-grid-system';
